import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '../internal/variants.js';
import { Icon } from '../primitives/Icon.js';
export function Citation({ citation, title, onClick, inline = false }) {
    return (_jsxs("span", { className: "cite", children: [_jsx("span", { className: cx(onClick && 'cite-link'), role: onClick ? 'button' : undefined, tabIndex: onClick ? 0 : undefined, onClick: onClick, children: citation }), !inline && title && _jsxs("span", { className: "dimtext", children: [" \u00B7 ", title] })] }));
}
/**
 * Uncited — the incomplete-evidence marker (core.css `.uncited`). A version with no
 * citation cannot advance past draft; this badge makes that gap legible.
 */
export function Uncited() {
    return (_jsxs("span", { className: "uncited", children: [_jsx(Icon, { name: "alert", size: 11 }), "uncited \u2014 incomplete"] }));
}
//# sourceMappingURL=Citation.js.map